import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Button, Container, Typography } from '@mui/material'

import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'
import AddIcon from '@mui/icons-material/Add'
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded'

import ActivityHistory from 'src/components/SideMenuAudit/ActivityHistory'
import { AlertComponent } from 'src/components/Alert/AlertComponent'
import { ActivityContext } from 'src/context/ActivityContext'
import useProtectedPage from 'src/hooks/useProtectedPage'
import { goToCampaignResult, goToCreateCampaign } from 'src/routes/coordinator'
import { getPermissions } from 'src/service/authService'
import CampaignTable from './components/Table/CampaignTable'

const Campaigns = () => {
  useProtectedPage()
  const { t } = useTranslation()
  const history = useNavigate()
  const { openDrawer } = useContext(ActivityContext)

  const permissions = JSON.parse(getPermissions())

  return (
    <Container
      sx={{
        mt: '96px',
        '.MuiDataGrid-row': {
          minHeight: '62px!important',
          '.MuiDataGrid-cell': {
            paddingTop: '8px',
            paddingBottom: '8px',
            minHeight: '62px!important',
          },
        },
        width: openDrawer ? 'calc(100% - 280px)' : '100%',
      }}
    >
      <AlertComponent />
      <Box
        component="div"
        sx={{
          color: '#FF5E1E',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: '24px',
        }}
      >
        <Box sx={{ display: 'flex', gap: '8px' }}>
          <CampaignOutlinedIcon />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              fontSize: '20px',
              lineHeight: '160%',
              letterSpacing: ' 0.15px',
              color: ' #FF5E1E',
              marginTop: '-3px',
            }}
          >
            {t('campaign.header')}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {
            permissions?.auditory?.includes('auditory:list') && <ActivityHistory path="campanhas" keySubtitle="name" />
          }
        </Box>
      </Box>
      <Box
        sx={{
          mb: '40px',
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: {
            xs: 'column',
            sm: 'column',
            md: 'row',
            lg: 'row',
            xl: 'row',
          },
          gap: '16px',
          width: openDrawer ? 'calc(100% - 280px)' : '100%',
        }}
      >
        <Button
          onClick={() => goToCreateCampaign(history)}
          disabled={!permissions?.campaign?.includes("campaign:create")}
          variant="outlined"
          sx={{
            gap: '6px',
            width: openDrawer ? '100%' : '49%',
            height: '36px',
            ':hover': {
              backgroundColor: '#FF5E1E',
              color: '#ffff',
            },
          }}
        >
          <AddIcon sx={{ width: '24px', height: '24px' }} />
          {t('campaign.button.create_campaign')}
        </Button>

        <Button
          onClick={() => {
            goToCampaignResult(history)
            return
          }}
          disabled={!permissions?.reports?.includes("reports:campaign")}
          variant="outlined"
          sx={{
            gap: '8px',
            width: openDrawer ? '100%' : '49%',
            height: '36px',
            color: 'rgba(0, 0, 0, 0.6)',
            borderColor: 'rgba(0, 0, 0, 0.6)',
            ':hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              color: '#ffff',
              borderColor: 'rgba(0, 0, 0, 0.6)',
            },
          }}
        >
          <BarChartRoundedIcon sx={{ width: '24px', height: '24px' }} />
          {t('campagin.result.button.cta')}
        </Button>
      </Box>

      <CampaignTable />
    </Container>
  )
}
export default Campaigns
